import { useState } from 'react'
import { Link } from 'react-router-dom'
import { EnrollmentModal } from '../../components/EnrollmentModal'

export function Privacy() {
  const [enrollmentModalOpen, setEnrollmentModalOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl sm:text-2xl font-bold text-blue-600">EMR</Link>
            <div className="flex items-center space-x-4">
              <Link to="/login" className="text-gray-700 hover:text-blue-600 transition">Sign In</Link>
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

        <div className="prose prose-lg max-w-none text-gray-700 space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
            <p>
              EMR System ("we", "our", or "us") is committed to protecting the privacy and security of your personal
              information and Protected Health Information (PHI). This Privacy Policy describes how we collect, use,
              disclose, and protect your information when you use our electronic medical records platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Information We Collect</h2>
            <p>We collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong>Account Information:</strong> Name, email, organization, role, and contact details</li>
              <li><strong>Health Information:</strong> Patient records, diagnoses, treatments, and clinical notes</li>
              <li><strong>Usage Data:</strong> Log files, device information, and platform usage patterns</li>
              <li><strong>Billing Information:</strong> Payment details and billing records</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. How We Use Your Information</h2>
            <p>We use collected information to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Provide and maintain our EMR services</li>
              <li>Process healthcare transactions and billing</li>
              <li>Ensure compliance with healthcare regulations</li>
              <li>Improve our platform and user experience</li>
              <li>Communicate important updates and support</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Protection</h2>
            <p>
              We implement industry-standard security measures including:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>End-to-end encryption (AES-256) for data at rest and in transit</li>
              <li>Multi-factor authentication</li>
              <li>Regular security audits and penetration testing</li>
              <li>Access controls and audit logging</li>
              <li>Secure data centers with SOC 2 Type II certification</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Compliance</h2>
            <p>Our platform is compliant with:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong>HIPAA</strong> (United States) - Health Insurance Portability and Accountability Act</li>
              <li><strong>PIPEDA</strong> (Canada) - Personal Information Protection and Electronic Documents Act</li>
              <li><strong>Provincial Health Acts</strong> - PHIPA (Ontario), HIA (Alberta), FIPPA (BC)</li>
              <li><strong>GDPR</strong> (European Union) - General Data Protection Regulation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Access your personal information</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data (subject to legal retention requirements)</li>
              <li>Export your data in a portable format</li>
              <li>Opt out of non-essential communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Contact Us</h2>
            <p>
              For privacy-related inquiries or to exercise your rights, contact our Privacy Officer:
            </p>
            <p className="mt-4">
              Email: privacy@emrsystem.com<br />
              Address: 123 Healthcare Drive, Toronto, ON M5V 1A1, Canada
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="text-white hover:text-blue-400 transition">← Back to Home</Link>
          <p className="mt-4 text-sm">&copy; {new Date().getFullYear()} EMR System. All rights reserved.</p>
        </div>
      </footer>

      <EnrollmentModal
        isOpen={enrollmentModalOpen}
        onClose={() => setEnrollmentModalOpen(false)}
      />
    </div>
  )
}

